<template>
  <CRow>
    <CCol col="12">
      <CButtonToolbar>
        <CButton size="lg" color="ghost-success" shape="pill" @click="$router.push({name: 'New Course',})"><CIcon size="lg" name="cil-plus"/></CButton>
      </CButtonToolbar>
    </CCol>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CDataTable
            outlined
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :fields="coursesUiMeta"
            :items="courses"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            @row-clicked="rowClicked"
            :pagination="{ align: 'center'}"
            @page-change="pageChange"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #periods="{item}">
              <td>
                <template v-if="item.periods">
                  <div v-for="(period, index) in item.periods.split(',')" :key="period + '-' + index">
                    {{period.split('~')[0].substring(0, 5)}} ~ {{period.split('~')[1].substring(0, 5)}}
                  </div>
                </template>
              </td>
            </template>
            <template #image_url="{item}">
              <td>
                <img v-if="item.image_url" :src="item.image_url" style="width: 100px;"/>
              </td>
            </template>
            <template #updated_at="{item}">
              <td>
                {{item.updated_at ? new Date(item.updated_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
            <template #created_at="{item}">
              <td>
                {{item.created_at ? new Date(item.created_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
            <template #together_course_group="{item}">
              <td>
                {{item.together_course_group ? item.together_course_group : ''}}
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{courses.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'

export default {
  name: 'Courses',
  data () {
    return {
      activePage: 1,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      courses: state => state.course.courses,
      coursesUiMeta: state => state.course.coursesUiMeta,
    }),
  },
  methods: {
    ...mapActions({
      listCourses: 'course/listCourses',
    }),
    ...mapMutations({
      setCourses: 'course/setCourses',
    }),
    rowClicked (item) {
      this.$router.push({path: `course/${item.invisible_id}`})
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
  },
  created () {
  },
  mounted () {
    this.listCourses()
  },
  destroyed () {
    this.setCourses([])
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
}
</script>
